import { render, staticRenderFns } from "./PackingTaskCard.vue?vue&type=template&id=a8000906&scoped=true&"
import script from "./PackingTaskCard.vue?vue&type=script&lang=js&"
export * from "./PackingTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./PackingTaskCard.vue?vue&type=style&index=0&id=a8000906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8000906",
  null
  
)

export default component.exports